'use strict';

var React = require('react');

var SvgCropIcon = function SvgCropIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 3.25c0-.414-.336-.75-.75-.75s-.75.336-.75.75v1.25h-1.25c-.414 0-.75.336-.75.75s.336.75.75.75h1.25v7.75c0 .966.784 1.75 1.75 1.75h7.75v1.25c0 .414.336.75.75.75s.75-.336.75-.75v-1.25h1.25c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-1.25v-7.75c0-.966-.784-1.75-1.75-1.75h-7.75v-1.25Zm0 2.75v7.75c0 .138.112.25.25.25h7.75v-7.75c0-.138-.112-.25-.25-.25h-7.75Z"
  }));
};
SvgCropIcon.displayName = "CropIcon";

exports.SvgCropIcon = SvgCropIcon;
